import { useAppStore } from 'app_alegra_commons/app'
import { Version } from '../interfaces/Versions'
import ENV from '../../../environment.json'

const VUE_APP_ENVIROMENT = process.env.VUE_APP_ENVIROMENT || 'local'

export const allVersions = [
  'chile',
  'argentina',
  'nigeria',
  'southAfrica',
  'kenya',
  'colombia',
  'usa',
  'spain',
  'republicaDominicana',
  'mexico',
  'panama',
  'costaRica',
  'peru',
  'other',
]

const allVersionsCode = {
  chile: 'cl',
  argentina: 'ar',
  nigeria: 'ng',
  southAfrica: 'za',
  kenya: 'ke',
  colombia: 'co',
  usa: 'us',
  spain: 'es',
  republicaDominicana: 'do',
  mexico: 'mx',
  panama: 'pa',
  costaRica: 'cr',
  peru: 'pe',
}

const allVersionsCodeReverse = {
  cl: 'chile',
  ar: 'argentina',
  ng: 'nigeria',
  za: 'southAfrica',
  ke: 'kenya',
  co: 'colombia',
  us: 'usa',
  es: 'spain',
  do: 'republicaDominicana',
  mx: 'mexico',
  pa: 'panama',
  cr: 'costaRica',
  pe: 'peru',
}

export const plansFeature = {
  free: 'free',
  demo: 'demo',
  readonly: 'readonly',
  // Emprendedor
  entrepreneur: 'emprendedor',
  emprendedor: 'emprendedor',
  pyme: 'pyme',
  pro: 'pro',
  plus: 'plus',
  // Enterprise
  corporativo: 'corporativo',
  corporate: 'corporativo',
}

export const timeZones = {
  chile: 'America/Santiago',
  argentina: 'America/Argentina/Buenos_Aires',
  nigeria: 'Africa/Lagos',
  southAfrica: 'Africa/Johannesburg',
  kenya: 'Africa/Nairobi',
  colombia: 'America/Bogota',
  usa: 'America/New_York',
  spain: 'Europe/Madrid',
  republicaDominicana: 'America/Santo_Domingo',
  mexico: 'America/Mexico_City',
  panama: 'America/Panama',
  costaRica: 'America/Costa_Rica',
  peru: 'America/Lima',
  other: 'America/Santiago',
} as const

export type TimezoneValues = (typeof timeZones)[Version]

export const isVersion = (value: string) => {
  return allVersions.includes(value)
}

export const getVersionCode = (value: Version) => {
  return allVersionsCode[value]
}

export const getVersionByCode = (value: string) => {
  return allVersionsCodeReverse[value] || 'other'
}

export const getVersion = app_store => {
  // const store = app_store()
  const store = app_store
  return store.appVersion
}

export const getVersionApp = () => {
  const store = useAppStore()
  return store.appVersion
}

export const getPlansFeatureKeys = () => Object.keys(plansFeature)

const productKeys = {
  'alegra-web': 'contabilidad',
  'alegra-shop': 'tienda',
  'alegra-ne': 'nomina',
  'alegra-pos': 'POS',
  'alegra-invoicing': 'facturacion',
  'alegra-calculator': 'calculadora',
}

export const productKeysLiteral = Object.keys(productKeys)

export type ProductKeysType = keyof typeof productKeys

export const getProducteKeyByQuery = (query: keyof typeof productKeys) => {
  return productKeys[query]
}

export const domainsAlegraByProduct = {
  'alegra-web': 'app.alegra.com',
  'alegra-shop': 'shop.alegra.com',
  'alegra-ne': 'nomina.alegra.com',
  'alegra-pos': 'pos.alegra.com',
  'alegra-invoicing': 'invoicing.alegra.com',
  'alegra-calculator': 'calcula.alegra.com',
}

const enviromentKeysDomain = {
  'alegra-web': 'BASE_URL',
  'alegra-shop': 'BASE_URL_SHOP_ALEGRA',
  'alegra-ne': 'BASE_URL_NE_ALEGRA',
  'alegra-pos': 'BASE_URL_POS_ALEGRA',
  'alegra-invoicing': 'BASE_URL_INVOICING_ALEGRA',
  'alegra-calculator': 'BASE_URL_CALCULATOR_ALEGRA',
}

export const getDomainAlegraByProduct = (product: ProductKeysType) => {
  return ENV[VUE_APP_ENVIROMENT][enviromentKeysDomain[product]]
}
